import { gql } from '@apollo/client';

export const GRAPH_TYPES = {
  MATRIX_INFO: 'matrixInfoRequest',
  USER_INFO: 'userInfoRequest',
};

export const matrixInfoRequest = (userAddress) => {
  const addressFilter = userAddress.toLowerCase();
  return `{
      user(id: "${addressFilter}") { 
        levels {
          levelNumber
          recyclesTotal
          totalReward
          reward24Timestamp
          reward24Data
          lastRewardDay
          expiredAt
          activationTimes
          matrixs(first: 1000, orderBy: id, orderDirection: asc) {
            id
            place1 {
              value
              receiver {
                id
              }
              realReceiver {
                id
              }
              user {
                id
              }
              status
            }
            place2 {
              value
              receiver {
                id
              }
              realReceiver {
                id
              }
              user {
                id
              }
              status
            }
            place3 {
              value
              receiver {
                id
              }
              realReceiver {
                id
              }
              user {
                id
              }
              status
            }
            place4 {
              value
              receiver {
                id
              }
              realReceiver {
                id
              }
              user {
                id
              }
              status
            }
            place5 {
              value
              receiver {
                id
              }
              realReceiver {
                id
              }
              user {
                id
              }
              status
            }
            place6 {
              value
              receiver {
                id
              }
              realReceiver {
                id
              }
              user {
                id
              }
              status
            }
          }
        }
      }
    }`;
};

export const CHECK_UPLINE_ADDRESS = gql`
  query userData($user: String!) {
    users(where: { id: $user }) {
      id
      internalId
      refNumber
    }
  }
`;

export const CHECK_UPLINE_REFNUMBER = gql`
  query userData($uplineKey: String!) {
    users(where: { refNumber: $uplineKey }) {
      id
      internalId
      refNumber
    }
  }
`;

export const CHECK_UPLINE_INTERNAL_ID = gql`
  query userData($internalId: Int!) {
    users(where: { internalId: $internalId }) {
      id
      internalId
      refNumber
    }
  }
`;

export const GET_TOTAL_STATS = gql`
  {
    stats(first: 1) {
      id
      totalUsers
      totalUsers24Timestamp
      totalTokens
      totalTokens24Timestamp
      totalTokens24Data
      totalBurned
      totalBurned24Timestamp
      totalBurned24Data
    }
  }
`;

export const GET_ALL_TOTAL_STATS = gql`
  {
    stats(first: 1) {
      totalUsers
      totalUsers24Timestamp

      x2TotalTokens
      x2TotalTokens24Timestamp
      x2TotalTokens24Data

      x4TotalTokens
      x4TotalTokens24Timestamp
      x4TotalTokens24Data
    }
  }
`;

export const GET_USER_DATA = gql`
  query userData($user: String!) {
    user(id: $user) {
      id
      internalId
      totalPartners
      partners24Timestamp
      totalTeam
      team24Timestamp
      totalRewardX2
      totalRewardX4
      x2IncomeLevel
      x4IncomeLevel
      registrationTime
      referral {
        id
        internalId
      }
      refNumber
      levelsX2 {
        isActivated
        levelNumber
        recyclesTotal
        totalReward
        reward24Timestamp
        reward24Data
        firstLineReward24
        firstLineRewardDay
        structureReward24
        structureRewardDay
        lastRewardDay
      }
      levelsX4 {
        isActivated
        levelNumber
        recyclesTotal
        totalReward
        reward24Timestamp
        reward24Data
        firstLineReward24
        firstLineRewardDay
        structureReward24
        structureRewardDay
        lastRewardDay
      }
    }
  }
`;

export const GET_PARTNERS_24 = gql`
  query userData($user: String!) {
    users(where: { referral: $user }) {
      id
      internalId
      registrationTime
    }
  }
`;

export const GET_USER_PARTNERS = gql`
  query userData($user: String!) {
    users(first: 1000, orderBy: registrationTime, orderDirection: desc, where: { referral: $user }) {
      id
      internalId
      totalPartners
      totalRewardX2
      totalRewardX4
      registrationTime
      registrationTransaction
      levelsX2 {
        levelNumber
        isActivated
      }
      levelsX4 {
        levelNumber
        isActivated
      }
    }
  }
`;

export const GET_MATRIX_DATA = gql`
  query matrixData($user: String!) {
    user(id: $user) {
      x2IncomeLevel
      x4IncomeLevel
      levelsX2 {
        levelNumber
        recyclesTotal
        totalReward
        reward24Timestamp
        reward24Data
        lastRewardDay
        totalPartners
        totalTeam
        isActivated
        blocked
        missedPartners
        missedProfit
        matrixs(first: 1000, orderBy: id, orderDirection: asc) {
          id
          place1 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
          place2 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
        }
      }
      levelsX4 {
        levelNumber
        recyclesTotal
        totalReward
        reward24Timestamp
        reward24Data
        lastRewardDay
        totalPartners
        totalTeam
        isActivated
        blocked
        missedPartners
        missedProfit
        matrixs(first: 1000, orderBy: id, orderDirection: asc) {
          id
          place1 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
          place2 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
          place3 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
          place4 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
          place5 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
          place6 {
            transaction
            value
            receiver {
              id
              internalId
            }
            realReceiver {
              id
              internalId
            }
            user {
              id
              internalId
            }
            status
          }
        }
      }
    }
  }
`;

export const GET_LEADERBOARD_USERS = gql`
  {
    users(first: 100, orderBy: totalReward, orderDirection: desc) {
      id
      internalId
      totalReward
      totalRewardX2
      totalRewardX4
      totalPartners
      totalTeam
    }
  }
`;

export const GET_LEADERBOARD_USERS_X2 = gql`
  {
    users(first: 100, orderBy: totalRewardX2, orderDirection: desc) {
      id
      internalId
      totalRewardX2
      totalPartners
    }
  }
`;

export const GET_LEADERBOARD_USERS_X4 = gql`
  {
    users(first: 100, orderBy: totalRewardX4, orderDirection: desc) {
      id
      internalId
      totalRewardX4
      totalPartners
    }
  }
`;

export const GET_LEADERBOARD_USERS_FLINE = gql`
  query userData($partners: [String!]!) {
    users(first: 100, orderBy: totalReward, orderDirection: desc, where: { referral_in: $partners }) {
      id
      internalId
      referral {
        id
        internalId
      }
      totalReward
      totalRewardX2
      totalRewardX4
    }
  }
`;

export const GET_LAST_EVENTS = gql`
  {
    lastEvents(first: 54, orderBy: timestamp, orderDirection: desc, subgraphError: allow) {
      id
      eventType
      identifier
      timestamp
      transaction
      value
      user {
        id
        internalId
      }
    }
  }
`;

export const GET_TOP30_USERS = gql`
  query getTop30Users($addresses: [String!]!) {
    users(where: { id_in: $addresses }) {
      id
      internalId
    }
  }
`;
